export const DOCUMENT_MANAGEMENT_EDUCATION_DIALOG_VIEWED_LOCAL_STORAGE_KEY = 'document_management_education_dialog_viewed';
export const ACCOUNT_ID_LOCAL_STORAGE_KEY = 'account_id';
